<template>
    <div class="header">
        <table style="width:100%">
            <tr>
                <td style="width:80%">
                    <div class="news">
                        <slot></slot>
                    </div>
                </td>
                <td>
                    <div style="margin-left:10px" class="header-text">
                        Bảng tin 4.0 TopCV
                    </div>
                </td>
            </tr>
        </table>
        
    </div>
   
    
</template>

<script>
export default {
    name: 'TopCVHeader'
}
</script>
<style>
.news{
    /* margin-top: 34px; */
}
.header{
    padding-top: 1.5em;
    padding-bottom: 1em;
    background: #fff;
    padding-left: 1em;
    padding-right: 1em;
    background: #fff;
}
.header-text{
    text-align: center;
    font-size: 2em;
}
</style>




// WEBPACK FOOTER //
// src/components/TopCVHeader.vue